/* eslint no-useless-escape: 0 */
export default function checkApiKey(text = null) {
  // Check the format of the Ably API key from the demo endpoint
  const re = /^([a-z0-9_\-]{6,}\.[a-z0-9_\-]{6,}\:[a-z0-9_\-]{12,})$/i;
  if (!text || typeof text !== 'string' || !re.test(text)) {
    throw new Error('Invalid API key');
  }
  return text;
}
